export default __webpack_public_path__ + "static/media/Resume.188d39cb.pdf";